import { WrapNav } from '../_types/wrap-nave.type'

const PREMIUM_WRAP_NAV: WrapNav = {
  sections: [
    {
      title: 'Overview',
      targetId: 'premium-overview',
      subSections: [
        {
          title: 'Portfolio Performance',
          targetId: 'premium-portfolio-performance'
        },
        {
          title: 'Market Overview',
          targetId: 'premium-market-overview'
        },
        {
          title: 'Videos',
          targetId: 'premium-videos'
        }
      ]
    },
    {
      title: 'Promotions',
      targetId: 'premium-promotions',
      subSections: [
        {
          title: 'Direct AXXESS',
          targetId: 'premium-direct-axxess'
        },
        {
          title: 'Trading App',
          targetId: 'premium-trading-app'
        },
        {
          title: 'Academy',
          targetId: 'premium-academy'
        }
      ]
    },
    {
      title: 'Analysis',
      targetId: 'premium-analysis',
      subSections: [
        {
          title: 'Market Commentary',
          targetId: 'premium-market-commentary'
        },
        {
          title: 'Market Position',
          targetId: 'premium-market-position'
        }
      ]
    },
    {
      title: 'Trading',
      targetId: 'premium-trading',
      subSections: [
        {
          title: 'Short Term Strategy',
          targetId: 'premium-short-term'
        },
        {
          title: 'Sector Rotation',
          targetId: 'premium-sector-rotation'
        },
        {
          title: 'Long Term Trades',
          targetId: 'premium-long-term'
        }
      ]
    },
    {
      title: 'Research',
      targetId: 'premium-research',
      subSections: [
        {
          title: 'Our Systems',
          targetId: 'premium-systems'
        },
        {
          title: 'Trader Z',
          targetId: 'premium-trader-z'
        },
        {
          title: 'Stock of the Day',
          targetId: 'premium-stock-of-day'
        }
      ]
    },
    {
      title: 'Legal',
      targetId: 'premium-legal',
      subSections: []
    }
  ]
}

export default PREMIUM_WRAP_NAV
